export type CapabilityDeltaAction =
  | 'summary_start'
  | 'summary_delta'
  | 'summary_complete'
  | 'tools_changed';

export function isCapabilityDeltaAction(action: unknown): action is CapabilityDeltaAction {
  return action === 'summary_start'
    || action === 'summary_delta'
    || action === 'summary_complete'
    || action === 'tools_changed';
}

export function shouldProcessCapabilityDelta(
  action: unknown,
  recentlyVisible: boolean,
  suppressUntilNextSend: boolean,
  focusChanged = false,
): boolean {
  if (!isCapabilityDeltaAction(action)) return true;
  // Focus switches must always refresh the capability menu — stale pills (e.g. admin
  // threads/memories/files only) persist if tab-return suppression blocks tools_changed.
  if (focusChanged && action === 'tools_changed') return true;
  if (suppressUntilNextSend) return false;
  if (recentlyVisible) return false;
  return true;
}
